import { h, Component } from 'preact'
import React from 'react';
import data from 'backend-data/index.js.erb'
import Cookies from 'js-cookie'
// import { connect } from 'react-redux'
// import { setPopupTrigger } from 'embed/actions'
import {
  mfToken, showPopup, isMobile, isProductPage, isShopifyPlatform,
  isCartPage, detectIEEdge, getCurencyRate, getCurencyISO, tractGA4Events} from 'embed/helpers'

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonId: 'mf_button',
      mfToken: mfToken(),
      bounceLeave: false,
      variantQuantity: false
    }
  }

  componentDidMount() {
    const { userSettings } = this.props
    this.setState({variantQuantity: userSettings.check_variant_quantity})
    this.clickButtonListner()
    this.receiveMessage()
    this.handleVariantChange()
    this.triggerLeave()
    setTimeout(() => {
      this.handleVariantChange()
    }, 1000)
  }

  clickButtonListner() {
    const button = document.querySelector("#mf_container button, #mf_button button");
    this.addEventListenersForButton(button)
  }

  addEventListenersForButton(button) {
    if (button) {
      button.addEventListener('clickMFButton', (e) => {
        e.preventDefault();
        this.setState({ bounceLeave: true })
      }, false);
    }
  }

  handleVariantChange() {
    const elements = document.querySelectorAll(
      '.mf_product_form select, .mf_product_form input' + this.props.userSettings.change_handler
    )
    elements.forEach(el => {
      el.addEventListener('change', () => {
        setTimeout(() => {
          this.props.setProducts()
          if(this.state.variantQuantity){
            this.props.setProductVariantStock()
          }
        }, 500)
      });
    })
  }

  triggerLeave() {
    if (isMobile() || !(this.props.products.length && this.isRenderIframe())) return
    const { userSettings } = this.props
    if ((isProductPage() && userSettings.product_exit_offer) || (isCartPage() && userSettings.cart_exit_offer)) {
      setTimeout(() => {
        document.body.addEventListener('mouseleave', (e) => {
          const height = detectIEEdge() ? 10 : 0
          if (!this.state.bounceLeave && e.clientY <= height && !this.props.popupTrigger) {
            showPopup()
            tractGA4Events({
              category: "MAO - Offers",
              action: "MAO - Exit Offer Opened",
              label: 'Auto open Make An Offer popup',
              trackingId: userSettings && userSettings.google_analytics_code,
              analyticsActive: userSettings.theme_setting.data.show_gac
            });
            this.setState({ bounceLeave: true })
          }
        });
      }, 1000);
    }
  }

  receiveMessage() {
    window.addEventListener('message', (e) => {
      const { userSettings, products } = this.props
      const result = products && products.reduce((obj, product) => ({...obj, product}), {})
      e.preventDefault();
      switch (e.data.type) {
        case 'close':
          tractGA4Events({
            category: "MAO - Offers",
            action: "MAO - Popup Close Icon clicked",
            label: 'On User click Close icon on Make An Offer Popup',
            trackingId: userSettings && userSettings.google_analytics_code,
            analyticsActive: userSettings.theme_setting.data.show_gac
          })
          let iframe = document.getElementById('iframe-div')
          iframe.style.display = "none";
          return
        case 'set_offers':
          let offers = Cookies.get('mf_offers') && JSON.parse(Cookies.get('mf_offers')) || []
          let date = new Date()
          // set expiration date (12 hours until now)
          date.setHours(date.getHours() + 12)
          window.makeAnOfferData.firstSet = true;
          Cookies.set('mf_offers', offers.concat(e.data.offers), { expires: date });
          return
        case 'add_offer_to_cart':
          let addToCartData = {
            items: [
              {
                id: e.data.variant_id,
                quantity: e.data.quantity
              }
            ]
          }

          fetch("/cart/add.js", {
            body: JSON.stringify(addToCartData),
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
          }).then(function(response) {
            fetch(`/checkout?discount=${e.data.discount_code}`).then(function(response) {
              window.location = "/cart"
            });
          })

          return
        case 'submit_form':
          tractGA4Events({
            action: 'MAO - Offer Submitted',
            category: result && result.product.title,
            label: `SKU: ${result && result.product.sku} || Product Amount: ${result && result.product.price} || Offer Amount: $${e.data.offer_amount}`,
            trackingId: userSettings && userSettings.google_analytics_code,
            analyticsActive: userSettings.theme_setting.data.show_gac
          })
          return
        case 'checkout_link':
          tractGA4Events({
            category: 'MAO - Offers',
            action: 'MAO - Checkout Link clicked',
            label: 'On Click Checkout link',
            trackingId: userSettings && userSettings.google_analytics_code,
            analyticsActive: userSettings.theme_setting.data.show_gac
          })
          return
      }
    }, false);
  }

  createOfferUrl() {
    let url = '&';
    this.props.products.forEach((product) => {
      url += Object.keys(product).map(k => {
        if (!Array.isArray(product[k])) {
          return 'products[][' + encodeURIComponent(k) + ']=' + encodeURIComponent(product[k])
        }
      }).join('&') + '&';
    })
    
    let combineWith = ''
    if (Cookies.get('mf_offers') && !window.makeAnOfferData.firstSet) {
      let offersIds = JSON.parse(Cookies.get('mf_offers')).map((o) => { return o.id })
      offersIds.forEach(function (id) {
        combineWith += '&combine_with[]=' + id
      })
    }

    var email = this.props.data.customer_email || '';
    var currencyISO = getCurencyISO();
    var curencyRate = getCurencyRate();
    var customerToken = ((window.MakeAnOffer || {}).config || {}).customer_token
    var cartToken = ((window.MakeAnOffer || {}).config || {}).cart_token

    return `${location.protocol}//${data.hostUrl}/offers/new?mf_tkn=${this.state.mfToken}` +
           `&email=${email}&currency_iso=${currencyISO}&currency_rate=${curencyRate}${combineWith}${url}&customer_token=${customerToken}&cart_token=${cartToken}`;
  }

  isRenderIframe() {
    const s = this.props.userSettings
    if (isProductPage(s)) {
      return s.product_button || s.product_exit_offer || (isMobile() && s.product_timed_overlay)
    } else {
      return s.cart_exit_offer || s.cart_timed_overlay
    }
  }

  isCartDataComplete() {
    return ((window.MakeAnOffer || {}).config || {}).cart_token && ((window.MakeAnOffer || {}).config || {}).customer_token
  }

  isDisabledInShopfront() {
    return this.props.userSettings.disabled_in_shopfront
  }

  onLoadIframe() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const mf_popup_valid = urlParams.get('mf_popup_valid')
    makeAnOfferData.iframeLoaded = true;

    if (mf_popup_valid == 'true') {
      showPopup();
      // this.props.setPopupTrigger(true)
    } else if (mf_popup_valid == 'false') {
      showPopup('show_mf_sorry_message');
    }
  }

  render() {
    if (this.props.products.length && this.isRenderIframe() && !this.isDisabledInShopfront() && (!isShopifyPlatform() || this.isCartDataComplete())) {
      return (
        <div id='iframe-div'>
          <iframe
            src={this.createOfferUrl()}
            allowtransparency='true'
            frameborder='0'
            scrolling='no'
            id='mfIframe'
            onLoad={() => this.onLoadIframe()}
            sandbox="allow-same-origin allow-top-navigation allow-forms allow-scripts allow-popups"
            class='mfIframe'>
          </iframe>
        </div>
      )
    }
  }
}

// const mapStateToProps = (state, ownProps) => {
//   return {}
// }

// const mapDispatchToProps = (dispatch, ownProps) => {
//   return {
//     setPopupTrigger: (trigger) => {
//       dispatch(setPopupTrigger(trigger))
//     }
//   }
// }

// export default connect(mapStateToProps, mapDispatchToProps)(Popup);
export default Popup;
